import { useState } from "react";
import { Auth } from "aws-amplify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import {
  View,
  TextField,
  SelectField,
  CheckboxField,
  Text,
} from "@aws-amplify/ui-react";
import { getServerTime } from "../../utils/Util";

const AccountManageGamen = (props: any) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  //更新後のアカウント情報を入れる変数
  const [editedUser, setEditedUser] = useState(props.userinfo.currentUser);
  // メール受信同意の変更前
  const beforeMailCheck =
    props.userinfo.currentUser["custom:marketingmailreceive"];
  const beforeMailDateTime =
    props.userinfo.currentUser["custom:marketmaildatetime"];

  const handleClose = () => {
    setEditedUser(props.userinfo.currentUser);
    setShow(false);
  };
  const handleShow = () => {
    setEditedUser(props.userinfo.currentUser);
    setShow(true);
  };

  function updateUserKakunin() {
    updateUserAttributes();
  }

  const handleClickMaileReceive = async (e: {
    target: { checked: boolean; value: any };
  }) => {
    if (e.target.checked.toString() === beforeMailCheck) {
      // チェック状態が変更前と同じ場合、元の値を設定
      setEditedUser((prevState: any) => ({
        ...prevState,
        "custom:marketingmailreceive": beforeMailCheck,
        "custom:marketmaildatetime": beforeMailDateTime,
      }));
    } else {
      const serverTime = await getServerTime();
      setEditedUser((prevState: any) => ({
        ...prevState,
        "custom:marketingmailreceive": e.target.checked.toString(),
        "custom:marketmaildatetime": serverTime ? serverTime.toISOString() : "",
      }));
    }
  };

  async function updateUserAttributes() {
    try {
      //スピナーを表示
      setLoading(true);

      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const updateUserObj: any = {
        name: typeof editedUser.name !== "undefined" ? editedUser.name : "",
        "custom:company":
          typeof editedUser["custom:company"] !== "undefined"
            ? editedUser["custom:company"]
            : "",
        "custom:department":
          typeof editedUser["custom:department"] !== "undefined"
            ? editedUser["custom:department"]
            : "",
        "custom:director":
          typeof editedUser["custom:director"] !== "undefined"
            ? editedUser["custom:director"]
            : "",
        address:
          typeof editedUser.address !== "undefined" ? editedUser.address : "",
        "custom:tel":
          typeof editedUser["custom:tel"] !== "undefined"
            ? editedUser["custom:tel"]
            : "",
        "custom:purposeofuse":
          typeof editedUser["custom:purposeofuse"] !== "undefined"
            ? editedUser["custom:purposeofuse"]
            : "business",
        "custom:marketingmailreceive":
          typeof editedUser["custom:marketingmailreceive"] !== "undefined"
            ? editedUser["custom:marketingmailreceive"]
            : "",
        "custom:marketmaildatetime":
          typeof editedUser["custom:marketmaildatetime"] !== "undefined"
            ? editedUser["custom:marketmaildatetime"]
            : "",
      };

      const result = await Auth.updateUserAttributes(user, updateUserObj);
      console.log(result); // SUCCESS
      //Emailの値を追加
      updateUserObj["email"] = props.userinfo.currentUser.email;
      //画面に表示している値の更新
      props.userinfo.setCurrentUser(updateUserObj);
      //アカウント編集モーダルウインドウを閉じる
      alert("アカウントを更新しました");

      handleClose();
    } catch (err) {
      console.log(err);
      alert("アカウントの更新に失敗しました");
    } finally {
      //スピナーを非表示
      setLoading(false);
    }
  }

  return (
    <>
      <View className="d-flex flex-column align-items-center">
        <Button
          variant="outline-primary"
          size="sm"
          onClick={handleShow}
          style={{ margin: "10px auto" }}
        >
          アカウントの編集
        </Button>
      </View>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>アカウントの編集</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            label="名前"
            defaultValue={editedUser.name}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                name: event.target.value,
              }));
            }}
          ></TextField>
          <TextField
            label="会社名・所属"
            defaultValue={editedUser["custom:company"]}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                "custom:company": event.target.value,
              }));
            }}
          ></TextField>
          <TextField
            label="部署"
            defaultValue={editedUser["custom:department"]}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                "custom:department": event.target.value,
              }));
            }}
          ></TextField>
          <TextField
            label="役職"
            defaultValue={editedUser["custom:director"]}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                "custom:director": event.target.value,
              }));
            }}
          ></TextField>
          <TextField
            label="所在地・住所"
            defaultValue={editedUser.address}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                address: event.target.value,
              }));
            }}
          ></TextField>
          <TextField
            label="電話番号"
            defaultValue={editedUser["custom:tel"]}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                "custom:tel": event.target.value,
              }));
            }}
          ></TextField>
          <SelectField
            label="利用用途"
            defaultValue={editedUser["custom:purposeofuse"]}
            onChange={(event) => {
              setEditedUser((prevState: any) => ({
                ...prevState,
                "custom:purposeofuse": event.target.value,
              }));
            }}
          >
            <option value="business">ビジネスでのご利用</option>
            <option value="private">プライベートでのご利用</option>
          </SelectField>
          <CheckboxField
            className="bs-color-checkbox pt-3"
            label="MAPPLE法務局地図ビューアからの各種案内のメールを受け取る"
            defaultChecked={
              editedUser["custom:marketingmailreceive"] === "true"
            }
            name="custom:marketingmailreceive"
            value={editedUser["custom:marketingmailreceive"]}
            onChange={handleClickMaileReceive}
          />
          <Text style={{ fontSize: 13, padding: "0.5em 2em" }}>
            チェックボックスの変更がメール配信システムに反映されるまで、時間がかかる場合があります。一時的にメールが届く可能性がございますので、あらかじめご了承ください。
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={handleClose}>
            キャンセル
          </Button>
          <div className="flex-fill" />
          <Button
            variant="primary"
            onClick={updateUserKakunin}
            disabled={loading}
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}
            更新する
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountManageGamen;
